import { render, staticRenderFns } from "./AdminFormPreview.vue?vue&type=template&id=35bb49cc&scoped=true&"
import script from "./AdminFormPreview.vue?vue&type=script&lang=js&"
export * from "./AdminFormPreview.vue?vue&type=script&lang=js&"
import style0 from "./AdminFormPreview.vue?vue&type=style&index=0&id=35bb49cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb49cc",
  null
  
)

export default component.exports